import React, { useContext } from "react";
import { SelfieSearchContext } from "../SelfieSearchContext";
const delImg = require("../../styles/delete.svg");

const FilterByImage = ({
  selectedImage,
  updateImageFilter
}: {
  selectedImage: string | null;
  updateImageFilter: (imageUrl: string | null, clearSelfie: boolean) => void;
}) => {
  const context = useContext(SelfieSearchContext);
  return (
    <div className="selfie-wrap filter-s hidden-xs hidden-sm">
      {selectedImage && <img src={selectedImage} />}
      <span className="div-del">
        <span
          className="selfie-del-btn"
          onClick={() => updateImageFilter(null, true)}
        >
          <img src={delImg} />
        </span>
      </span>
      <button
        onClick={context.openSelfieUploadPopup}
        className="btn secondary-btn btn-small"
      >
        Change Photo
      </button>
    </div>
  );
};

export default FilterByImage;
